const request = require('request');
const config = require('./config');

const post = (token,formData) => {
  return new Promise((resolve,reject) => {
    const url = `${config.URL_BACKEND}/protocoloLogistico`;
    const response = fetch(url, {
      headers: {
        'User-Token': token
      },
      method: 'POST',
      body: formData
    });
    resolve(response);
  });
};

const get = (token) => {
  return new Promise((resolve,reject) => {
    request({
      headers: {
        'User-Token': token
      },
      uri: config.URL_BACKEND+'/protocoloLogistico',
      method: 'GET',
    }, (err, res, body) => {
      if (err) return reject(err);
      resolve({err: err, res: res, body: body});
    });
  });
};

module.exports = {
    post:post,
    get:get
}